// Mock data for Swiss Insurance Broker Homepage

export const services = [
  {
    id: 1,
    title: 'Vorsorge',
    description: `Säule 3a & 3b

Die private Vorsorge in der Schweiz stützt sich auf zwei Varianten: die gebundene Vorsorge Säule 3a und die flexible Säule 3b.

3a ist der steuerliche Geheimtipp: Einzahlungen können jedes Jahr vom steuerbaren Einkommen abgezogen werden – ein legaler „Rabatt“, den viele liegen lassen. Das Kapital ist zweckgebunden für die Pension, Wohneigentum oder Selbstständigkeit, dafür profitieren Sie von klaren Vorteilen und attraktiven Renditechancen, besonders bei modernen, fondsgebundenen Lösungen.

3b hingegen ist der Freigeist der Vorsorgewelt: komplett flexibel, jederzeit verfügbar und ideal für Vermögensaufbau, Absicherung der Familie oder clevere Ergänzungen zur klassischen Altersvorsorge.

Und eine kleine Insider-Info: Viele Policen aus der Säule 3b sind erb- und konkursgeschützt – ein Detail, das im Ernstfall sehr viel Wert hat.`,
    icon: 'PiggyBank'
  },
  {
    id: 2,
    title: 'Krankenkasse',
    description: `KVG & VVG

In der Schweiz regeln zwei unterschiedliche Gesetzeswelten das Thema Versicherung: KVG und VVG.

Das KVG (Krankenversicherungsgesetz) bestimmt die obligatorische Grundversicherung – klar definiert, einheitliche Leistungen, aber enorme Prämienunterschiede je nach Kasse und Modell. Der Preisvorteil zwischen zwei Anbietern kann problemlos mehrere hundert Franken pro Jahr ausmachen. Ein Vergleich ist hier kein „Nice to have“, sondern bares Geld in der Haushaltskasse.

Das VVG (Versicherungsvertragsgesetz) deckt die Welt der Zusatzversicherungen und vieler privater Policen ab – von Spitalzusatz bis Zahnversicherung. Die Leistungen unterscheiden sich teils massiv, und genau hier wird es heikel: Wer die Angebote nicht vergleicht, riskiert entweder Überversicherung oder teure Lücken, die erst im Ernstfall auffallen.

Ein sauberer Vergleich schützt also nicht nur den Geldbeutel, sondern auch die Nerven.`,
    icon: 'Heart'
  },
  {
    id: 3,
    title: 'Privathaftpflicht',
    description: `Schutz vor Schadenersatzforderungen

Die Privathaftpflicht gehört zu den wichtigsten Absicherungen für Privatpersonen und deckt Schäden an Dritten.

Sie springt ein, wenn Sie jemandem einen Schaden zufügen: ob Sie ein teures Handy fallen lassen, beim Velofahren ein Auto touchieren oder ein Wasserschaden in der Mietwohnung verursacht wird. Ohne Privathaftpflicht zahlen Sie alles aus eigener Tasche – und das kann bei Personenschäden schnell in die Hunderttausende gehen.

Doch Vorsicht: Privathaftpflicht ist nicht gleich Privathaftpflicht. Deckungssummen, Selbstbehalte, Mieterschadendeckungen, grobfahrlässiger Schaden und Leistungen für Haustiere unterscheiden sich teils enorm. Manche Policen übernehmen sogar Streitigkeiten aus Mietverhältnissen oder weiten den Schutz auf Nebenjobs aus, andere sparen genau an diesen Punkten.

Der spannende Teil: Ein sauberer Vergleich kostet Sie kein Geld, spart aber häufig mehrere hundert Franken pro Jahr und stellt sicher, dass Sie im Ernstfall nicht mit einem unvollständigen Schutz dastehen. Denn eine Privathaftpflicht soll vor allem eins: zuverlässig funktionieren, wenn Sie sie wirklich brauchen.`,
    icon: 'Shield'
  },
  {
    id: 4,
    title: 'Hausratsversicherung',
    description: `Schutz für Ihr Zuhause

Die Hausratversicherung schützt alles, was Ihr Zuhause erst wirklich zu Ihrem Zuhause macht.

Dazu gehören Möbel, Elektronik, Kleidung, Sportgeräte, Schmuck – kurz gesagt, Ihr ganzes privates Inventar. Ob Feuer, Wasser, Diebstahl, Sturm und viele weitere Ereignisse: Die Hausratversicherung ersetzt den Neuwert Ihres beschädigten oder gestohlenen Eigentums.

Was viele nicht wissen: Die richtige Versicherungssumme ist entscheidend. Wird sie zu tief angesetzt, droht eine Unterversicherung – und dann wird im Schadenfall nur ein Teil ersetzt. Eine kleine Anpassung kann hier enorme Auswirkungen auf Ihre tatsächliche Entschädigung haben.

Ebenso spannend: Viele Policen bieten heute optionale Erweiterungen wie Simpel-Diebstahl auswärts, Cyber-Schutz, Sportgeräte weltweit oder Glasbruch – und die Unterschiede zwischen den Anbietern sind teilweise dramatisch.

Auch finanziell lohnt sich der Blick aufs Detail: Selbstbehalte, Kombirabatte und der Einsatz moderner Smart-Home-Systeme können die Jahresprämie erstaunlich deutlich reduzieren. Der Vergleich spart also nicht nur Geld, sondern verhindert auch, dass man im Ernstfall mit einem Schutz dasteht, der nur halb so viel kann, wie man eigentlich dachte.`,
    icon: 'Home'
  },
  {
    id: 5,
    title: 'Rechtsschutzversicherung',
    description: `Rechtlicher Beistand, wenn Sie ihn brauchen

Rechtliche Streitigkeiten sind wie ungeplante Gewitter: Sie kommen selten gelegen und kosten schnell Nerven, Zeit und vor allem Geld. Eine Rechtsschutzversicherung sorgt dafür, dass Sie in solchen Situationen nicht alleine im Regen stehen.

Sie übernimmt Anwaltskosten, Gutachten, Prozessgebühren und hilft Ihnen, Ihre Ansprüche professionell durchzusetzen – egal ob im Verkehr, im Privatleben oder im Beruf.

Was viele unterschätzen: Die Leistungen und Ausschlüsse unterscheiden sich zwischen den Anbietern oft stärker als bei fast jeder anderen Versicherung. Manche decken bereits Streitigkeiten bei Online-Käufen oder Mietangelegenheiten ab, andere nicht. Einige übernehmen Mediationen, andere nur Gerichtsverfahren. Und der Preis? Schwankt gerne mal um mehrere hundert Franken – für praktisch den gleichen Schutz.

Gerade deshalb sind Vergleiche hier Gold wert: Wer nicht prüft, riskiert, dass das vermeintliche Sicherheitspaket im entscheidenden Moment ein Loch hat. Mit der richtigen Police hingegen haben Sie einen starken Partner im Rücken, der dafür sorgt, dass Sie im Rechtsfall nicht den Kürzeren ziehen, weder finanziell noch nervlich.`,
    icon: 'Scale'
  },
  {
    id: 6,
    title: 'Fahrzeugversicherungen',
    description: `Haftpflicht, Teilkasko & Vollkasko

Die Autoversicherung in der Schweiz besteht aus zwei Ebenen: obligatorische Haftpflicht und freiwillige Teil- und Vollkasko.

Die Haftpflicht ist obligatorisch und deckt Schäden an Dritten. Ohne sie gibt es keine Zulassung – Punkt. Doch die Prämienunterschiede zwischen den Versicherern sind enorm: identisches Auto, identischer Fahrer, aber oft mehrere hundert Franken Preisunterschied pro Jahr. Ein gründlicher Vergleich ist hier kein Hobby, sondern ein finanzieller Pflichttermin.

Die Teilkasko und Vollkasko sind freiwillig – aber entscheidend, wenn das eigene Fahrzeug geschützt werden soll. Ob Parkschäden, Diebstahl, Marderbisse, Glasbruch oder selbstverschuldete Unfälle: Die Leistungen variieren teilweise drastisch. Wer einfach „irgendwo“ abschliesst, riskiert im Schadenfall unangenehme Überraschungen – und unangenehme Überraschungen sind in der Versicherungswelt so willkommen wie Hagelkörner auf einem frischen Lack.

Ein oft unterschätzter Punkt: Selbstbehalte, Bonus-Malus-Systeme, Parkschaden-Deckungen und Zeitwert vs. Neuwertentschädigung können den realen Nutzen einer Police massiv beeinflussen.`,
    icon: 'Car'
  },
  {
    id: 7,
    title: 'KMU Versicherungen',
    description: `Umfassender Schutz für Ihr Unternehmen

Ein Unternehmen zu führen bedeutet Chancen zu nutzen und Risiken intelligent zu steuern. Genau hier setzen KMU-Versicherungen an: Sie schützen das Geschäftsvermögen, die Mitarbeitenden und den Betrieb selbst vor finanziellen Stolpersteinen, die im Ernstfall existenzbedrohend werden können.

Ob Betriebshaftpflicht, Sachversicherung, Cyber-Schutz, Taggeldlösungen, Pensionskasse, Berufsunfähigkeit oder Flottenversicherung: Jede Branche hat ihre eigenen Risikoprofile. Ein Bäcker braucht andere Deckungen als ein IT-Dienstleister – und ein Architekt wiederum andere als ein Detailhändler. Wer hier einfach irgendein Standardpaket abschliesst, zahlt entweder zu viel oder ist im Ernstfall nicht korrekt geschützt.

Spannender Punkt, den viele KMU unterschätzen: Schon kleine Anpassungen wie die richtige Versicherungssumme, passende Selbstbehalte oder eine sauber definierte Betriebsbeschreibung können Tausende Franken an Prämien sparen – ohne Einbussen beim Schutz.

Und gerade im Bereich Cyber und Betriebsunterbruch gibt es zwischen den Anbietern enorme Leistungsunterschiede, die man unbedingt kennen sollte.`,
    icon: 'Briefcase'
  }
];

export const partners = [
  {
    id: 1,
    name: 'Swiss Life',
    logo: 'https://customer-assets.emergentagent.com/job_8a8efe14-e280-43f8-81be-49615652987c/artifacts/oqvk9no3_Swiss_Life_logo.svg',
    description: 'Führender Lebensversicherer und einer der grössten Pensionskassenverwalter der Schweiz'
  },
  {
    id: 2,
    name: 'AXA',
    logo: 'https://customer-assets.emergentagent.com/job_8a8efe14-e280-43f8-81be-49615652987c/artifacts/2r8vws4r_AXA-Logo.wine.png',
    description: 'Grösste Versicherungsgesellschaft der Schweiz mit umfassendem Angebot'
  },
  {
    id: 3,
    name: 'Generali',
    logo: 'https://customer-assets.emergentagent.com/job_8a8efe14-e280-43f8-81be-49615652987c/artifacts/0e154vux_1200px-Generali_logo.svg.png',
    description: 'Internationale Versicherungsgruppe mit starker Schweizer Präsenz'
  },
  {
    id: 4,
    name: 'Helsana',
    logo: 'https://customer-assets.emergentagent.com/job_8a8efe14-e280-43f8-81be-49615652987c/artifacts/jcf83w5t_Logo_Helsana.svg.png',
    description: 'Eine der führenden Krankenversicherungen der Schweiz'
  },
  {
    id: 5,
    name: 'Visana',
    logo: 'https://customer-assets.emergentagent.com/job_8a8efe14-e280-43f8-81be-49615652987c/artifacts/7a2n76uu_Visana_logo.svg.png',
    description: 'Schweizer Krankenversicherung mit umfassendem Service'
  },
  {
    id: 6,
    name: 'Assura',
    logo: 'https://customer-assets.emergentagent.com/job_8a8efe14-e280-43f8-81be-49615652987c/artifacts/ubdhhz5y_Assura_Logo.svg.png',
    description: 'Schweizer Krankenversicherung mit attraktiven Prämien'
  },
  {
    id: 7,
    name: 'Innova',
    logo: 'https://customer-assets.emergentagent.com/job_8a8efe14-e280-43f8-81be-49615652987c/artifacts/bb4eoaib_Logo_Innova.svg.png',
    description: 'Innovative Krankenversicherung in der Schweiz'
  },
  {
    id: 8,
    name: 'Swica',
    logo: 'https://customer-assets.emergentagent.com/job_8a8efe14-e280-43f8-81be-49615652987c/artifacts/uif1x8sa_Swica.svg.png',
    description: 'Schweizer Kranken- und Unfallversicherer'
  }
];

export const features = [
  {
    id: 1,
    title: 'Digital & Persönlich',
    description: 'Beratung digital oder vor Ort - ganz nach Ihren Wünschen',
    icon: 'Monitor'
  },
  {
    id: 2,
    title: 'Unabhängige Beratung',
    description: 'Wir vergleichen alle Schweizer Versicherungen für Sie',
    icon: 'CheckCircle'
  },
  {
    id: 3,
    title: 'Jahrelange Expertise',
    description: 'Profitieren Sie von unserer langjährigen Erfahrung',
    icon: 'Award'
  },
  {
    id: 4,
    title: 'Kostenlose Beratung',
    description: 'Unsere Erstberatung ist für Sie vollständig kostenfrei',
    icon: 'Gift'
  }
];

// Calendly URL
export const CALENDLY_URL = 'https://calendly.com/vivalo-info/30min';